export const Locales = {
  enGb: {
    shorthand: 'en-gb',
    displayName: 'EN',
  },
  deDe: {
    shorthand: 'de-de',
    displayName: 'DE',
  },
};

export const LocalesArray = (Object.keys(Locales) as (keyof typeof Locales)[]).map(key => Locales[key]);

export const DefaultLocale = Locales.enGb;
